<template>
  <div>
    <FieldLabel v-if="showFieldHelp" :label="item.name" :help="fieldHelp" :field-id="item.id" :modal-key="modalKey" />

    <v-row>
      <v-col>
    <v-btn @click="createElements" x-small color="primary"
      >ajouter un élément</v-btn>
    les options
      </v-col>
    </v-row>
    <v-row class="mt-1">
      <v-col cols="12" md="4">
        <v-file-input
          v-model="importFile"
          accept=".xlsx,.xls,.csv"
          dense
          hide-details
          label="Fichier Excel"
        ></v-file-input>
      </v-col>
      <v-col cols="12" md="2" class="d-flex align-center">
        <v-checkbox
          v-model="importHasHead"
          hide-details
          dense
          label="1re ligne entete"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="2" class="d-flex align-center">
        <v-btn
          color="secondary"
          x-small
          :loading="importLoading"
          @click="scanProductsFromExcel"
        >
          Scanner produits
        </v-btn>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          v-model="selectedProductRow"
          :items="detectedProducts"
          item-text="text"
          item-value="value"
          dense
          hide-details
          clearable
          label="Produit a importer"
        ></v-select>
      </v-col>
    </v-row>
    <v-row class="mt-1">
      <v-col cols="12" md="3">
        <v-text-field
          v-model="importGridField"
          dense
          hide-details
          label="Cle champ grille cible (optionnel)"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="importProductNameField"
          dense
          hide-details
          label="Cle champ nom produit (optionnel)"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="importSupplierNameField"
          dense
          hide-details
          label="Cle champ nom fournisseur (optionnel)"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3" class="d-flex align-center">
        <v-btn
          color="secondary"
          x-small
          :loading="importLoading"
          @click="importSelectedProductFromExcel"
        >
          Importer le produit selectionne
        </v-btn>
        <span v-if="lastImportedGridRefs.length" class="ml-2 caption">
          refs grille: {{ lastImportedGridRefs.join(", ") }}
        </span>
      </v-col>
    </v-row>
      <v-row>
        <v-col>
        <v-expansion-panels>

          <v-expansion-panel v-for="(elem, i) in model" :key="i + 'e'">

            <v-expansion-panel-header>
              <div class="d-flex align-center w-100">
             {{ elem.element ? elem.element : 'nouveau groupe' }}
             <span class="mr-2" v-if="elem.required">| (obligatoire)</span>
             <span class="mr-2">| {{elem.options.length}} options</span>
             <span class="mr-2" v-if="elem.tva">| TVA {{ elem.tva }}%</span>
                <v-btn x-small icon color="error"
                class="ml-auto" @click.stop="
                model.splice(i, 1);
                keyup(item, model);"><v-icon small>mdi-delete</v-icon>
                </v-btn>
          </div>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" md="6">
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="elem.element"
                      label="Nom du groupe d'option"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-select v-model="elem.typeselect" :items="typeselect" label="Type d'option"></v-select>
                  </v-col>
                  <v-col>
                    <v-select v-model="elem.unit" :items="unit" label="Unité"></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-checkbox v-model="elem.required" label="Option obligatoire ?"></v-checkbox>
                  </v-col>
                  <v-col>
                    <v-text-field v-model="elem.tva" label="TVA"></v-text-field>
                  </v-col>
                </v-row>
                
              </v-col>
              <v-col cols="12" md="6">
        <v-expansion-panels>

          mes options : <v-btn @click="createOptions(elem)" x-small color="secondary" >ajouter une option</v-btn >
          <v-expansion-panel v-for="(option, j) in elem.options" :key="j + 'o'">
            <v-expansion-panel-header>
              <div class="d-flex align-center w-100">
                {{ option.title ? option.title : 'nouvelle option' }}
                <span class="mr-2" v-if="'puv' in option">Vente à {{ option.puv }}€/U.</span>
                <span class="mr-2" v-if="'pua' in option">
                  <span class="mr-2" v-if="option.patype=='fixe'">P.A.:{{ option.pua }}€/U.</span>
                  <span class="mr-2" v-if="option.patype=='grille'">P.A. sur grille {{ option.grille }}.</span>
                  <span class="mr-2" v-if="'coef' in option">coef. {{ option.coef }}</span>
                  <span class="mr-2" v-if="'marge' in option">marge {{ option.marge }}€</span>
                </span>
                <span class="mr-2" v-if="option.isq">(aj. de quantité)</span>
                <span class="mr-2" v-if="option.default"> - option par défaut</span>
                <v-btn x-small icon color="error"
                class="ml-auto" @click.stop="
                elem.options.splice(j, 1);
                keyup(item, model);"><v-icon small>mdi-delete</v-icon>
                </v-btn>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-btn @click="applyvalue(option,'pv')" x-small :color="'puv' in option ? 'primary' : 'secondary'">Appliquer un prix de vente</v-btn>
              <v-btn @click="applyvalue(option,'pa')" x-small :color="'pua' in option ? 'primary' : 'secondary'">Appliquer un prix d'achat</v-btn>
              <v-btn @click="applyvalue(option,'pp')" x-small :color="'pup' in option ? 'primary' : 'secondary'">Appliquer un tarif de pose</v-btn>
              <v-row>
                <v-col><v-text-field v-model="option.title" label="Titre de l'option"></v-text-field></v-col>
                <v-col>
                  <!-- Description en TinyMCE local -->
                  <editor
                    v-model="option.descr"
                    :init="editorConfig"
                    @onEditorChange="onDescrChange"
                    @EditorChange="onDescrChange"
                  />
                  <div class="caption mt-1">
                    Tokens dynamiques: <code>{_unite_}</code> et <code>{_q_}</code>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="'pua' in option" class="elevation-2">
                <v-col class="col-12">Prix d'achat
                  <v-btn @click="applyvalue(option,'pafixe')" x-small >P.A. fixe</v-btn>
                  <v-btn @click="applyvalue(option,'pagrille')" x-small >P.A. sur grille</v-btn>
                  <v-btn @click="applyvalue(option,'marge')" x-small :color="'marge' in option ? 'primary' : 'secondary'">Appliquer une marge</v-btn>
                  <v-btn @click="applyvalue(option,'coef')" x-small :color="'coef' in option ? 'primary' : 'secondary'">Appliquer un coef.</v-btn>
                </v-col>
                <v-col>
                  <v-text-field v-model="option.pua" v-if="option.patype=='fixe'" label="Prix d'achat"></v-text-field>
                  <v-text-field v-model="option.grille" v-if="option.patype=='grille'" label="Identifiant de la grille"></v-text-field>
                  <v-text-field
                    v-model="option.grid_axis1_label"
                    v-if="option.patype=='grille'"
                    label="Libellé coordonnée 1"
                  ></v-text-field>
                  <v-text-field
                    v-model="option.grid_axis2_label"
                    v-if="option.patype=='grille'"
                    label="Libellé coordonnée 2"
                  ></v-text-field>
                </v-col>
                <v-col>
                <v-text-field v-if="'marge' in option" v-model="option.marge" label="Marge fixe (ex: 20)"></v-text-field>
                <v-text-field v-if="'coef' in option" v-model="option.coef" label="Coefficient (ex: 1.2)"></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="'puv' in option" class="elevation-2">
                <v-col>Prix de vente :
                <v-text-field v-model="option.puv" label="Prix de vente (visuel)"></v-text-field>
                <v-text-field v-model="option.tva" label="TVA"></v-text-field>
                </v-col>

              </v-row>
                <v-row>
                    <v-col> 
                        <v-text-field v-model="option.pup" v-if="'pup' in option" label="Prix de pose"></v-text-field> 
                         <v-checkbox v-model="option.isq" label="Permettre l'ajout de quantité ?"></v-checkbox> 
                        <v-checkbox v-model="option.affichage" label="Affichage ?"></v-checkbox> 
                        <v-checkbox v-model="option.principal" label="Principal ?"></v-checkbox> 
                        <v-checkbox v-model="option.detail" label="Detail description ?"></v-checkbox> 
                        <v-checkbox v-model="option.default" label="Sélection par défaut ?"></v-checkbox> 
                    </v-col> 
              </v-row>
            </v-expansion-panel-content>
            </v-expansion-panel>
            </v-expansion-panels> 
                
              </v-col>
            </v-row>
            </v-expansion-panel-content>

          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>


  </div>
</template>

<script>
import mixinFields from "../../mixins/Fields";
import mixinConditionsFields from "../../mixins/conditionsFields";
import Editor from "@tinymce/tinymce-vue";

// TinyMCE local assets
import "tinymce/tinymce.min";
import "tinymce/icons/default";
import "tinymce/themes/silver";
import "tinymce/models/dom";
import "tinymce/plugins/advlist";
import "tinymce/plugins/autolink";
import "tinymce/plugins/lists";
import "tinymce/plugins/link";
import "tinymce/plugins/charmap";
import "tinymce/plugins/code";
import "tinymce/plugins/preview";

export default {
  name: "optionsCreator",

  mixins: [mixinFields, mixinConditionsFields],
  components: {
    editor: Editor
  },

  data: function () {
    return {
      openedPanel : '',
      openedPanel2 : '',
      importFile: null,
      importHasHead: true,
      importLoading: false,
      detectedProducts: [],
      selectedProductRow: "",
      importGridField: this.item?.defaultprops?.grillefield ?? "quotationsGrille",
      importProductNameField: this.item?.defaultprops?.productnamefield ?? "quotationsNom",
      importSupplierNameField: this.item?.defaultprops?.suppliernamefield ?? "quotationsFournisseur",
      lastImportedGridRefs: [],
      margeCoefMemory: {},
      defaultElement: {
        element: "",
        key: "",
        options: [],
        unit: "",
        tva: "",
        typeselect: "",
        required: false,
      },
      defaultOptions: {
        key: "",
        title: "",
        descr: "",
        //puv: "",
        patype : "fixe",
        grid_axis1_label: "",
        grid_axis2_label: "",
        //pua: "100",
        //pup: "",
        tva : "",
        isq : false,
        affichage: false,
        principal: false,
        detail: false,
        default: false,
      },

      typemarge : '',
      
      typeselect: [
        { value: "select", text: "option unique avec liste déroulante" },
        { value: "radio", text: "options unique avec radio" },
        { value: "checkbox", text: "option multiple" },
      ],
      unit : [ { value: "m2", text: "M²" }, { value: "m3", text: "M3" }, { value: "P", text: "Pièce" }, { value: "S", text: "Service" }, { value: "ml", text: "M lineaire" }, { value: "l", text: "Litre" }, ],
      editorConfig: {
        language: "fr_FR",
        height: 260,
        menubar: false,
        branding: false,
        plugins: ["preview", "code", "advlist", "autolink", "lists", "link", "charmap"],
        toolbar: "undo redo | bold italic | alignleft aligncenter alignright | bullist numlist | link | code",
        base_url: "/tinymce",
        suffix: ".min"
      },
    };
  },

  watch: {
    importFile() {
      this.detectedProducts = [];
      this.selectedProductRow = "";
      this.lastImportedGridRefs = [];
    },
  },


  methods: {
    getMargeCoefMemory(option) {
      const optionKey = String(option?.key || "");
      if (!optionKey) return null;
      if (!Object.prototype.hasOwnProperty.call(this.margeCoefMemory, optionKey)) {
        this.$set(this.margeCoefMemory, optionKey, { marge: null, coef: null });
      }
      return this.margeCoefMemory[optionKey];
    },

    rememberCurrentMargeCoef(option) {
      const memory = this.getMargeCoefMemory(option);
      if (!memory) return;
      if (Object.prototype.hasOwnProperty.call(option, "marge")) {
        memory.marge = option.marge;
      }
      if (Object.prototype.hasOwnProperty.call(option, "coef")) {
        memory.coef = option.coef;
      }
    },

    createElements() {
      let newElement = JSON.parse(JSON.stringify(this.defaultElement));

      //creation du random key
      newElement.key = this.randomKey(5);
      this.model.push(newElement);
      this.keyup(this.item, this.model);
    },

    createOptions(elem) { 
        let newOption = JSON.parse(JSON.stringify(this.defaultOptions)); 
        newOption.key = this.randomKey(5); 
        newOption.tva = elem.tva; 
        elem.options.push(newOption); this.keyup(this.item, this.model); }, 

    normalizeImportedOptions(options) {
      if (!Array.isArray(options)) return [];
      return options.map((option) => {
        const normalized = {
          key: option?.key || this.randomKey(5),
          title: option?.title ?? "",
          descr: option?.descr ?? "",
          patype: option?.patype ?? "fixe",
          grid_axis1_label: option?.grid_axis1_label ?? "",
          grid_axis2_label: option?.grid_axis2_label ?? "",
          tva: option?.tva ?? "",
          isq: option?.isq === true,
          affichage: option?.affichage === true,
          principal: option?.principal === true,
          detail: option?.detail === true,
          default: option?.default === true,
        };

        if (option && Object.prototype.hasOwnProperty.call(option, "pua")) normalized.pua = option.pua;
        if (option && Object.prototype.hasOwnProperty.call(option, "marge")) normalized.marge = option.marge;
        if (option && Object.prototype.hasOwnProperty.call(option, "coef")) normalized.coef = option.coef;
        if (option && Object.prototype.hasOwnProperty.call(option, "pup")) normalized.pup = option.pup;
        if (option && Object.prototype.hasOwnProperty.call(option, "puv")) normalized.puv = option.puv;
        if (option && Object.prototype.hasOwnProperty.call(option, "grille")) normalized.grille = option.grille;

        return normalized;
      });
    },

    normalizeImportedGroups(groups) {
      if (!Array.isArray(groups)) return [];
      return groups.map((group) => ({
        element: group?.element ?? "",
        key: group?.key || this.randomKey(5),
        options: this.normalizeImportedOptions(group?.options),
        unit: group?.unit ?? "",
        tva: group?.tva ?? "",
        typeselect: group?.typeselect ?? "select",
        required: group?.required === true,
      })).filter((group) => group.options.length > 0);
    },

    buildImportPayload(mode = "scan") {
      const formData = new FormData();
      formData.append("importFile", this.importFile);
      formData.append("isHead", this.importHasHead);
      formData.append("mode", mode);
      if (mode === "import" && this.selectedProductRow) {
        formData.append("product_row", this.selectedProductRow);
      }
      return formData;
    },

    async scanProductsFromExcel() {
      if (!this.importFile) {
        this.$toast.warning("Selectionne un fichier avant scan");
        return;
      }

      this.importLoading = true;
      this.$store.dispatch("textOverlay", "Scan des produits excel");
      this.$store.dispatch("getoverlay", true);

      try {
        const resp = await this.API({
          type: "post",
          url: "devisconfig/import-options",
          params: this.buildImportPayload("scan"),
          apidefault: { headers: { "Content-Type": "multipart/form-data" } },
        });
        const payload = resp?.data ?? {};
        if (!payload.success) {
          this.$toast.error(payload.message || "Erreur de scan");
          return;
        }

        this.detectedProducts = Array.isArray(payload.products) ? payload.products : [];
        if (!this.detectedProducts.length) {
          this.$toast.warning("Aucun produit detecte dans ce fichier");
          return;
        }

        if (!this.selectedProductRow) {
          this.selectedProductRow = this.detectedProducts[0].value;
        }
        this.$toast.success(`${this.detectedProducts.length} produit(s) detecte(s)`);
      } catch (error) {
        this.$toast.error("Erreur pendant le scan du fichier");
      } finally {
        this.importLoading = false;
        this.$store.dispatch("getoverlay", false);
      }
    },

    resolveGridFieldTarget() {
      if (String(this.importGridField || "").trim() !== "") {
        this.importGridField = String(this.importGridField).trim();
        return this.importGridField;
      }
      const form = this.$store.getters.listForm(this.modalKey);
      const fields = form?.fields ?? {};
      const candidates = Object.keys(fields).filter((key) => /grille|abaque/i.test(key));
      if (candidates.length === 1) {
        this.importGridField = candidates[0];
        return candidates[0];
      }
      return "";
    },

    createImportInsert(key, reelvalue) {
      return {
        key,
        type: "valuefromfield",
        reelvalue,
        descr: "",
        guard: false,
        firstload: false,
        fromField: false,
      };
    },

    pushValueToTargetField(target, value, actionKey) {
      if (!target) return false;
      const form = this.$store.getters.listForm(this.modalKey);
      if (!form || !form.fields) {
        this.$toast.warning("Formulaire courant introuvable pour injecter les valeurs importees");
        return false;
      }
      if (!Object.prototype.hasOwnProperty.call(form.fields, target)) {
        this.$toast.warning(`Cle de champ introuvable dans le formulaire: ${target}`);
        return false;
      }

      const getConditionForm = this.$store.getters.getConditionForm;
      if (typeof getConditionForm === "function" && !getConditionForm(this.modalKey)) {
        this.$store.dispatch("initConditionForm", { page: this.modalKey });
      }

      const payload = {};
      payload[target] = {
        insert: [this.createImportInsert(actionKey, value)],
        remove: [],
      };
      this.$store.dispatch("changeConditionForm", { page: this.modalKey, datas: payload });

      // Fallback store direct to keep form state in sync even if a field component does not watch conditionForm.
      this.$store.dispatch("pushForm", {
        page: this.modalKey,
        champ: target,
        value,
      });
      return true;
    },

    pushImportedGridsToForm(grilles) {
      if (!Array.isArray(grilles) || !grilles.length) return false;
      const target = this.resolveGridFieldTarget();
      if (!target) return false;
      return this.pushValueToTargetField(
        target,
        grilles,
        `import_grille_${Date.now()}`
      );
    },

    resolveProductNameFieldTarget() {
      if (String(this.importProductNameField || "").trim() !== "") {
        this.importProductNameField = String(this.importProductNameField).trim();
        return this.importProductNameField;
      }
      const form = this.$store.getters.listForm(this.modalKey);
      const fields = form?.fields ?? {};
      const candidates = Object.keys(fields).filter((key) => /produit|libelle|designation|nom/i.test(key));
      if (candidates.length === 1) {
        this.importProductNameField = candidates[0];
        return candidates[0];
      }
      return "";
    },

    pushImportedProductNameToForm(productName) {
      const label = String(productName ?? "").trim();
      if (label === "") return false;
      const target = this.resolveProductNameFieldTarget();
      if (!target) return false;
      return this.pushValueToTargetField(
        target,
        label,
        `import_produit_nom_${Date.now()}`
      );
    },

    resolveSupplierNameFieldTarget() {
      if (String(this.importSupplierNameField || "").trim() !== "") {
        this.importSupplierNameField = String(this.importSupplierNameField).trim();
        return this.importSupplierNameField;
      }
      const form = this.$store.getters.listForm(this.modalKey);
      const fields = form?.fields ?? {};
      const candidates = Object.keys(fields).filter((key) => /fournisseur|supplier|vendor/i.test(key));
      if (candidates.length === 1) {
        this.importSupplierNameField = candidates[0];
        return candidates[0];
      }
      return "";
    },

    pushImportedSupplierNameToForm(supplierName) {
      const label = String(supplierName ?? "").trim();
      if (label === "") return false;
      const target = this.resolveSupplierNameFieldTarget();
      if (!target) return false;
      return this.pushValueToTargetField(
        target,
        label,
        `import_fournisseur_nom_${Date.now()}`
      );
    },

    async importSelectedProductFromExcel() {
      if (!this.importFile) {
        this.$toast.warning("Selectionne un fichier avant import");
        return;
      }
      if (!this.selectedProductRow) {
        this.$toast.warning("Selectionne un produit a importer");
        return;
      }

      this.importLoading = true;
      this.$store.dispatch("textOverlay", "Import du produit en cours");
      this.$store.dispatch("getoverlay", true);

      try {
        const resp = await this.API({
          type: "post",
          url: "devisconfig/import-options",
          params: this.buildImportPayload("import"),
          apidefault: { headers: { "Content-Type": "multipart/form-data" } },
        });

        const payload = resp?.data ?? {};
        if (!payload.success) {
          this.$toast.error(payload.message || "Echec de l import produit");
          return;
        }

        if (Array.isArray(payload.products)) {
          this.detectedProducts = payload.products;
        }

        const imported = this.normalizeImportedGroups(payload.data);
        this.model = imported;
        this.keyup(this.item, this.model);

        this.lastImportedGridRefs = Array.isArray(payload.grid_refs) ? payload.grid_refs : [];
        const grilles = Array.isArray(payload.grilles) ? payload.grilles : [];
        const gridsInjected = this.pushImportedGridsToForm(grilles);
        const productLabel = String(payload?.product?.name ?? payload?.product?.text ?? "");
        const productNameInjected = this.pushImportedProductNameToForm(productLabel);
        const supplierLabel = String(payload?.product?.supplier ?? "");
        const supplierNameInjected = this.pushImportedSupplierNameToForm(supplierLabel);

        const meta = payload.meta ?? {};
        this.$toast.success(
          `Import termine: ${meta.groups_count ?? imported.length} groupe(s), ${meta.options_count ?? 0} option(s), ${meta.grilles_count ?? grilles.length} grille(s)`
        );

        if (grilles.length && !gridsInjected) {
          this.$toast.warning("Grilles detectees mais non injectees (champ cible grille non defini)");
        } else if (grilles.length && gridsInjected) {
          this.$toast.success(`Grilles injectees dans le champ ${this.importGridField}`);
        }

        if (productLabel && !productNameInjected) {
          this.$toast.warning("Nom produit detecte mais non injecte (champ cible nom produit non defini)");
        } else if (productLabel && productNameInjected) {
          this.$toast.success(`Nom produit injecte dans le champ ${this.importProductNameField}`);
        }

        if (supplierLabel && !supplierNameInjected) {
          this.$toast.warning("Nom fournisseur detecte mais non injecte (champ cible fournisseur non defini)");
        } else if (supplierLabel && supplierNameInjected) {
          this.$toast.success(`Nom fournisseur injecte dans le champ ${this.importSupplierNameField}`);
        }

        if (Array.isArray(payload.warnings) && payload.warnings.length > 0) {
          payload.warnings.forEach((warning) => this.$toast.warning(String(warning)));
        }
      } catch (error) {
        this.$toast.error("Erreur pendant l import du produit");
      } finally {
        this.importLoading = false;
        this.$store.dispatch("getoverlay", false);
      }
    },
        
    applyvalue(option, type) {
      switch(type) {
        case 'marge' : {
          this.rememberCurrentMargeCoef(option);
          const margeMemory = this.getMargeCoefMemory(option);
          if('marge' in option) {
            this.$delete(option, "marge");
          } else {
            const marginValue = margeMemory && margeMemory.marge !== null && margeMemory.marge !== undefined
              ? margeMemory.marge
              : 0;
            this.$set(option, "marge", marginValue);
          }
        this.$delete(option, "coef");
        
        break;
        }
        case 'coef' :  {
          this.rememberCurrentMargeCoef(option);
          const coefMemory = this.getMargeCoefMemory(option);
          if('coef' in option) {
            this.$delete(option, "coef");
          } else {
            const coefValue = coefMemory && coefMemory.coef !== null && coefMemory.coef !== undefined
              ? coefMemory.coef
              : 1;
            this.$set(option, "coef", coefValue);
          }
        this.$delete(option, "marge");

        break;
        }
        case 'nomarge' :
          this.rememberCurrentMargeCoef(option);
          this.$delete(option, "marge");
          this.$delete(option, "coef");
          break;   
        case 'pa' :
          if('pua' in option) {
            this.$delete(option, "pua");
          } else {
            this.$set(option, "pua", 0);
            this.$delete(option, "puv"); 
          }
          
          break; 
        case 'pv' :
          if('puv' in option) {
            this.$delete(option, "puv");
          } else {
            this.$set(option, "puv", 0);
            this.$delete(option, "pua");
          }
          break;    
        case 'pp' :
          if('pup' in option) {
            this.$delete(option, "pup");
          } else {
            this.$set(option, "pup", 0);
          }
          break;  
        case 'pafixe' :
          this.$set(option, "patype", "fixe");
          break; 
        case 'pagrille' :
          this.$set(option, "patype", "grille");
          if (!Object.prototype.hasOwnProperty.call(option, "grid_axis1_label")) {
            this.$set(option, "grid_axis1_label", "");
          }
          if (!Object.prototype.hasOwnProperty.call(option, "grid_axis2_label")) {
            this.$set(option, "grid_axis2_label", "");
          }
          break; 
      }

      this.keyup(this.item, this.model);
    },

    onDescrChange() {
      this.keyup(this.item, this.model);
    },
  },
};
/*
définir l'array d'abaque : 1 colonne 

[
{"ref":"random",, "nom" : "SOLAIRE LAME 40","values": [ {"h":"","l":"","p":""},{"h":"","l":"","prix":""}, .... ] },
{"ref":"random", "nom" : "SOLAIRE LAME 40","values": [ {"h":"","l":"","p":""},{"h":"","l":"","prix":""}, .... ] }
]

liste des options :


typeselect : select, radio, checkbox,
unit : m2,m3,P,S,ml,l
required : si l'option est obligatoire ou facultative sur le produit
element : le nom globale de l'élément          
key : permet de retrouver le group d'option choisi  
    options :
    - key : random pour memoriser l'option dans le devis.
    - title : texte d'affichage de l'option lors du choix par le commercial.
    - descr : texte qui sera affiché sur le devis
    - puv : prix U de vente
    - pua : pu d'achat
    - pup : pu de pose
    - coef : appliqué soit sur pua de l'otpion (clé supprimé si aucune notion de coef mais notion de marge)
    - marge : marge fixe ajouté au prix d'achat du produit ( clé supprimé si notion de coef et pas de marge)
    - q : quantité d'élements choisi sur l'option (peut etre supprimé de l'array si aucune notion de qt)
    - default : selection automatique dès ouverture du devis (true, false)

[
{"element":"coffre", key:"random", options : [ {"key":"random", "title":"","descr":"","puv":"","pua":"100","pup":"","coef":"1.2","marge":"","q":"","default":false} ], "unit":"", "tva":"","typeselect":"","required":true, }
]




1 - table de stockage des produits qui font l'objet du choix dans les devis.
2 colonne obligatoires
 - colonne des options
 - colonne des abaques
 
 table fournisseur
 
 table produit
 
 table quotation : fournisseur <-> produit
 
 fournisseur_id, produits_id, options, abaque
 */
</script>

